import * as Draft from 'draft-js';

import { PageGenerationResult } from 'api/pageGenerations';
import { LIST_PLACEHOLDER_IMAGE_TYPE } from 'constants/index';

const { HIGHLIGHTS, FACTS } = LIST_PLACEHOLDER_IMAGE_TYPE;

export const getNewLandingData = (oldLandingData: any, newLandingData: PageGenerationResult) => {
  const createContent = (text: string) => Draft.ContentState.createFromText(text);
  const firstPropertyOverviewContent = createContent(newLandingData.content.propertyOverview.first);
  const secondPropertyOverviewContent = createContent(newLandingData.content.propertyOverview.second);
  const firstExperienceActivitiesContent = createContent(newLandingData.content.experienceActivities.first);
  const secondExperienceActivitiesContent = createContent(newLandingData.content.experienceActivities.second);
  const highlightsContent = createContent(newLandingData.content.highlights);
  const quickFactsContent = createContent(newLandingData.content.quickFacts);

  return {
    pages: [
      {
        ...oldLandingData.pages[0],
        blocks: [
          {
            type: 'header',
            availableInBasic: true,
            data: { subheadline: 'Property Overview' },
          },
          {
            type: 'text',
            availableInBasic: true,
            data: {
              text: firstPropertyOverviewContent.getPlainText(),
              raw: Draft.convertToRaw(firstPropertyOverviewContent),
            },
          },
          {
            type: 'image',
            availableInBasic: true,
            data: {},
          },
          {
            type: 'text',
            availableInBasic: true,
            data: {
              text: secondPropertyOverviewContent.getPlainText(),
              raw: Draft.convertToRaw(secondPropertyOverviewContent),
            },
          },
          {
            type: 'header',
            data: { subheadline: 'Experience & Activities' },
          },
          {
            type: 'text',
            data: {
              text: firstExperienceActivitiesContent.getPlainText(),
              raw: Draft.convertToRaw(firstExperienceActivitiesContent),
            },
          },
          {
            type: 'image',
            availableInBasic: true,
            data: {},
          },
          {
            type: 'text',
            data: {
              text: secondExperienceActivitiesContent.getPlainText(),
              raw: Draft.convertToRaw(secondExperienceActivitiesContent),
            },
          },
          ...(oldLandingData.pages[0]?.rooms?.length > 0
            ? [{ type: 'header', data: { subheadline: 'Accommodation', noMenu: true } }]
            : []),
          {
            type: 'accommodations',
            data: {},
          },
          {
            type: 'header',
            data: { subheadline: 'Fast Facts' },
          },
          {
            type: 'list',
            data: {
              items: [
                {
                  imagePlaceholder: HIGHLIGHTS,
                  titlePlaceholder: 'Highlights',
                  title: 'Highlights',
                  descPlaceholder: {
                    text: 'Amazing location \nExcellent wildlife viewing \nFantastic staff and menus \nPanoramic views \nBathtubs in every room',
                  },
                  desc: {
                    text: highlightsContent.getPlainText(),
                    raw: Draft.convertToRaw(highlightsContent),
                  },
                },
                {
                  imagePlaceholder: FACTS,
                  titlePlaceholder: 'Quick facts',
                  title: 'Quick facts',
                  descPlaceholder: {
                    text: 'Only 10 rooms \nMain pool \nAl fresco dining \nOwner-managed \nVery good wi-fi',
                  },
                  desc: {
                    text: quickFactsContent.getPlainText(),
                    raw: Draft.convertToRaw(quickFactsContent),
                  },
                },
              ],
            },
          },
        ],
      },
    ],
  };
};
